import React, { useState } from 'react';

import { Row, Col, Layout, Card, Divider, Image, Typography } from 'antd';
import Logo from "../../components/Graphics/Logo";
import EmailInput from "../../components/Inputs/EmailInput";


const PublicEntry = ({handleEmailChange}) => {

    return (
        <div style={{background:"url(https://storage.googleapis.com/finiat-web-static-resources/dramatic/black-depth.jpeg)", height:'100vh', backgroundSize: 'cover'}}>
            <>
                <div style={{background: 'transparent', padding: '30px'}}>
                    <Row justify={'center'} align={'top'} gutter={96} style={{marginTop: 100, background: 'transparent'}}>
                        <Col>
                            <Card className={'dark-shadow'} bordered={false} style={{width: 500, background: 'rgba(255, 255, 255, 0.12)', backdropFilter: 'blur(6px)', borderRadius: 5}}>
                                <Logo src={'https://storage.googleapis.com/finiat-web-static-resources/company-brands/finiat-white.png'}
                                      height={'100px'}
                                      width={'100px'}
                                />
                                <Divider/>
                                <EmailInput onEmailSubmit={(email) =>handleEmailChange(email)}
                                            label={<Typography.Text style={{color: 'white'}}>Please Enter Your Email</Typography.Text>}

                                />
                            </Card>

                        </Col>
                    </Row>
                </div>
            </>

        </div>
    );
};

export default PublicEntry;
